import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackPrintParameters extends TrackEventBaseParameters {}

const trackPrint = (parameters: TrackPrintParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "print", ...parameters }, options);
};

export default trackPrint;
